import { render } from "./TheReleaseStationContainer.vue?vue&type=template&id=48e992a2"
import script from "./TheReleaseStationContainer.vue?vue&type=script&lang=js"
export * from "./TheReleaseStationContainer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__